/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type MessageBannerCarousel_messages$ref = any;
export type MessageBanner_user$ref = any;
export type MessageBanner_user = {
    readonly registeredUserMessages: ReadonlyArray<{
        readonly " $fragmentRefs": MessageBannerCarousel_messages$ref;
    } | null> | null;
    readonly " $refType": MessageBanner_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "MessageBanner_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "registeredUserMessages",
      "name": "bannerMessages",
      "storageKey": null,
      "args": null,
      "concreteType": "MessageSetModule",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "MessageBannerCarousel_messages",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'e027c1ac5554a6a7800dcb2707fe399a';
export default node;
